<template>
  <div class="p-[20px] border border-solid border-steam rounded-[8px] overflow-visible vs-con-loading__container" id="customer-section-loading">
    <div class="flex justify-between items-center ">
      <div class="flex items-center gap-[4px]">
        <shipblu-icon iconLibrary="material" iconName="person" iconClass="text-industrial-revolution text-[24px]"/>
        <p class="text-lg text-young-night">{{ $t('Customer') }}</p>
      </div>
      <div v-if="$store.state.AppActiveUser.userRole === 'merchant' && merchantStatus === 'active' && ((common.defineOrderType(orderData) === 'returns' && common.getPermissions('return_orders', 'base', 'update')) || (common.defineOrderType(orderData) === 'delivery-orders' && common.getPermissions('delivery_orders', 'base', 'update')))">
        <div class="flex" v-if="orderData.status === 'created' || orderData.status === 'return_requested' || orderData.status === 'pickup_requested'">
          <feather-icon icon="EditIcon" svgClasses="h-5 w-5" class="text-silver cursor-pointer" 
            v-if="!editable && !(orderData.status === 'pickup_requested' && common.defineOrderType(orderData) === 'returns')" @click="editCustomerInformation()" />
        </div>
      </div>
      <div class="flex" v-else-if="$store.state.AppActiveUser.userRole === 'admin' || ($store.state.AppActiveUser.userRole === 'head-of-fleet' && localStorage.getItem('multipleWarehouses') === 'true') || $store.state.AppActiveUser.userRole === 'customer-support'">
        <feather-icon icon="EditIcon" svgClasses="h-5 w-5" class="text-silver cursor-pointer" 
          v-if="!editable && !(orderData.status === 'delivered' || orderData.status === 'returned' || orderData.status === 'collected' || orderData.status === 'returned_to_origin' || orderData.status === 'cancelled')" @click="editCustomerInformation()" />
      </div>
    </div>
    <div class="mt-6 grid grid-cols-2 gap-x-4 gap-y-6">
      <div>
        <p class="text-young-night sm:text-[14px] text-[12px] leading-tight" v-show="!editable">{{ $t('Full Name') }}</p>
        <div v-if="orderData.customer">
          <p v-show="!editable" class="sm:text-[14px] text-[12px] text-industrial-revolution">{{ orderData.customer.full_name }}</p>
          <div v-show="editable">
            <shipblu-input inputId="full-name" autocomplete="nofill" v-validate="'required'" name="full name" v-model="orderData.customer.full_name" type="text" :labelPlaceholder="$t('Full Name')" class="w-full"/>
            <span class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('full name')">{{ errors.first('full name') }}</span>
          </div>
        </div>
      </div>
      <div v-if="!($store.state.AppActiveUser.userRole === 'head-of-fleet' && localStorage.getItem('multipleWarehouses') === 'false') && $store.state.AppActiveUser.userRole !== 'manager'">
        <p class="text-young-night sm:text-[14px] text-[12px] leading-tight" v-show="!editable">{{ $t('Mobile Number') }}</p>
        <div>
          <div v-if="!editable" class="flex items-center mt-[6px]">
            <p class="text-industrial-revolution sm:text-[14px] text-[12px]">{{ orderData.customer.phone }}</p>
            <div class="flex items-center">
              <span @click="copied(orderData.customer.phone, 'phoneCopied')" class="material-icons-round text-2xl text-grey hover:text-primary cursor-pointer">copy_all</span>
              <span v-if="phoneCopied" class="absolute ml-6 text-xs ">{{ $t('Copied') }}</span>
            </div>
          </div>
          <div v-show="editable">
            <shipblu-input inputId="phone-number" autocomplete="nofill" v-validate="{ required: true, regex: /(^01[0,1,2,5]\d{8}$|^\u0660\u0661[\u0660,\u0661,\u0662,\u0665][\u0660-\u0669]{8}$)/ }" name="phone number" v-model="orderData.customer.phone" type="text" :labelPlaceholder="$t('Mobile Number')" class="w-full"/>
            <span class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('phone number')">{{ errors.first('phone number') }}</span>
          </div>
        </div>
      </div>
      <div  v-if="!($store.state.AppActiveUser.userRole === 'head-of-fleet' && localStorage.getItem('multipleWarehouses') === 'false') && $store.state.AppActiveUser.userRole !== 'manager'">
        <p class="text-young-night sm:text-[14px] text-[12px] leading-tight" v-show="!editable">{{ $t('Secondary Mobile Number') }}</p>
        <div v-if="!editable" class="flex items-center mt-[6px]">
          <p class="text-industrial-revolution sm:text-[14px] text-[12px]">{{ orderData.customer.secondary_phone ? orderData.customer.secondary_phone : 'N/A' }}</p>
          <div class="flex items-center">
            <p v-if="orderData.customer.secondary_phone" @click="copied(orderData.customer.secondary_phone, 'additionalPhoneCopied')" class="material-icons-round text-2xl text-grey hover:text-primary cursor-pointer">copy_all</p>
            <span v-if="additionalPhoneCopied" class="absolute ml-6 text-xs ">{{ $t('Copied') }}</span>
          </div>
        </div>
        <div v-show="editable">
          <shipblu-input inputId="secondary-phone-number" autocomplete="nofill" v-validate="{ regex: /(^0[0-9]\d{8,15}$|^\u0660\u0661[\u0660-\u0669][\u0660-\u0669]{8,15}$)/ }" name="secondary phone number" v-model="orderData.customer.secondary_phone" type="text" :labelPlaceholder="$t('Secondary Mobile Number')" class="w-full"/>
          <span class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('secondary phone number')">{{ errors.first('secondary phone number') }}</span>
        </div>
      </div>
      <div v-if="!editable" class="col-span-2">
        <div class="flex items-center gap-2">
          <p class=" text-young-night sm:text-[14px] text-[12px] leading-tight">{{ $t('Address') }}</p>
          <span v-if="orderData.customer.address.auto_zoned" class="flex items-center px-[6px] py-[2px] bg-carte-blanche text-primary rounded-[4px] text-[10px]">
            <shipblu-icon iconLibrary="phosphor" iconName="sparkle"/>
            {{ $t('Autozoned') }}
          </span>
        </div>
        <div class="text-industrial-revolution sm:text-[14px] text-[12px]">
          <p>{{ orderData.customer.address.line_1 }}, {{ orderData.customer.address.line_2 }}</p>
          <p>{{ $t(orderData.customer.address.zone.name) }}, {{ $t(orderData.customer.address.zone.city.name) }} , {{ $t(orderData.customer.address.zone.city.governorate.name) }}</p>
        </div>
      </div>
      <span v-show="editable"></span>
      <div v-show="editable" class="col-span-2">
        <shipblu-input inputId="address-line-one" v-validate="'required'" name="Full Address" :labelPlaceholder="$t('Full Address')" autocomplete="nofill" v-model="fullAddress" type="text" class="w-full" />
        <p class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('Full Address')">{{ $t('Full Address are required') }}</p>
      </div>
      <div v-show="editable" class="col-span-2">
        <shipblu-select v-validate="orderData.customer.address !== null ? '' : 'required'" :key="updatedZonesKey" :localize="true" :options="zones" optionLabel="name" inputId="input-zone" 
        :defaultValue="orderData.customer.address" :labelPlaceholder="$t('Zone')" name="zone" type="high_level" @selectedOptions="selectZoneOptions($event)"/>
        <p class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('zone')">{{ $t('Zone field is required') }}</p>
      </div>
      <div class="col-span-2">
        <p class="text-young-night mb-1 sm:text-[14px] text-[12px]" v-show="!editable">{{ common.defineOrderType(orderData) === 'delivery-orders'? $t('Delivery Notes') : $t('Pickup Notes') }}</p>
        <p v-show="!editable || localStorage.getItem('multipleWarehouses') !== 'true'" class="text-darkgray ">
          <pre v-if="orderData.order_notes && orderData.order_notes.includes('\n*')" class="whitespace-pre-wrap mt-[6px]">{{ orderData.order_notes ? orderData.order_notes : 'N/A' }}</pre>
            <span class="text-industrial-revolution" v-else>{{ orderData.order_notes ? orderData.order_notes : 'N/A' }}</span>
        </p>
        <div v-show="editable && localStorage.getItem('multipleWarehouses') === 'true'">
          <shipblu-input inputId="delivery-notes" autocomplete="nofill" v-validate="common.defineOrderType(orderData) === 'returns' ? 'required' : ''" name="delivery notes" v-model="orderData.order_notes" type="text" :labelPlaceholder="$t('Delivery Notes')" class="w-full"/>
            <span class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('delivery notes')">{{ errors.first('delivery notes') }}</span>
        </div>
      </div>
      <div v-if="common.defineOrderType(orderData) === 'cash-collections'">
        <p class="text-young-night sm:text-[14px] text-[12px] leading-tight" v-show="!editable">{{ $t('Amount') }}</p>
        <div>
          <p v-show="!editable" class="sm:text-[14px] text-[12px] text-industrial-revolution mt-[6px]">{{ orderData.amount }}</p>
          <div v-show="editable">
            <shipblu-input inputId="full-name" autocomplete="nofill" v-validate="'required|decimal'" name="amount" v-model="orderData.amount" type="text" :labelPlaceholder="$t('Amount')" class="w-full"/>
            <span class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('amount')">{{ errors.first('amount') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$store.state.AppActiveUser.userRole === 'merchant'">
      <div class="grid grid-cols-2 gap-4" v-if="orderData.status === 'created' || orderData.status === 'return_requested' || orderData.status === 'pickup_requested'">
        <shipblu-button class="mt-6 font-semibold" v-if="editable" @click="updateOrder()" :textButton="$t('Save')"/>
        <shipblu-button class="mt-6 font-semibold" v-if="editable" @click="cancelEdit()" color="secondary" :textButton="$t('Cancel')"/>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-4" v-else-if="$store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'head-of-fleet' || $store.state.AppActiveUser.userRole === 'customer-support'">
      <shipblu-button class="mt-6 font-semibold" v-if="editable" @click="updateOrder()" :textButton="$t('Save')"/>
      <shipblu-button class="mt-6 font-semibold" v-if="editable" @click="cancelEdit()" color="secondary" :textButton="$t('Cancel')"/>
    </div>
  </div>
</template>

<script>
import ShipbluCard from '@/layouts/components/ShipbluCard.vue'
import {sendRequest} from '@/http/axios/requestHelper.js'
import vSelect from 'vue-select'
import i18nData from '../../../i18n/i18nData'
import common from '../../../assets/utils/common'
import staticZones from '../../../assets/utils/geo.json'

export default {
  props: ['orderData', 'customerInfoCardLoading', 'merchantStatus'],
  data () {
    return {
      common,
      localStorage,
      editable: false,
      pickupPoints: [],
      serviceLevels: [],
      governorates: [],
      cities: [],
      customer: {
        address: {
          zone: {
            city: {
              governorate: {}
            }
          }
        },
        full_name:''
      },
      governorate: {},
      city: {},
      zone: {},
      phoneCopied: false,
      additionalPhoneCopied: false,
      updatedZonesKey: 0,
      zones: staticZones,
      fullAddress: ''
    }
  },
  watch: {
    'orderData' () {
      this.$validator.resume()
      if (this.orderData.delivery_order) {
        this.orderData = this.orderData.delivery_order
      }
      this.fullAddress = `${this.orderData.customer.address.line_1  } ${  this.orderData.customer.address.line_2 === '.' ? '' : this.orderData.customer.address.line_2  }`
      this.editable = false
      this.governorate = {
        id: this.orderData.customer.address.zone.city.governorate.id,
        name: this.orderData.customer.address.zone.city.governorate.name
      }
      this.city = {
        id: this.orderData.customer.address.zone.city.id,
        name: this.orderData.customer.address.zone.city.name
      }
      this.zone = {
        id: this.orderData.customer.address.zone.id,
        name: this.orderData.customer.address.zone.name
      }
    }
  },
  methods: {
    async copied (data, type) {
      try {
        await navigator.clipboard.writeText(data)
        this[type] = true
        setTimeout(() => {
          this[type] = false
        }, 750)
      } catch ($e) {
        this.$vs.notify({
          color:'dark',
          title:i18nData[this.$i18n.locale]['cannot copy!'],
          position: 'bottom-center'
        })
      }
    },
    editCustomerInformation () {
      this.editable = true
      this.updatedZonesKey++
    },
    loadServicesAvailability (id) {
      sendRequest(true, false, this, `api/v1/services-availability/?governorate_id=${id}&subscription_id=${this.orderData.merchant.subscription.id}`, 'get', null, true, 
        (response) => {
          const key = 'id'
          const packageSizes  = response.data.map(element => element.package_size)
          const serviceLevels = response.data.map(element => element.service_level)
          this.packageSizes = [...new Map(packageSizes.map(item => [item[key], item])).values()]
          this.serviceLevels = [...new Map(serviceLevels.map(item => [item[key], item])).values()]
        }
      )
    },
    cancelEdit () {
      this.editable = !this.editable
      this.$validator.pause()
      this.$emit('loadOrder')
    },
    updateOrder () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading({
            background: this.backgroundLoading,
            color: this.colorLoading,
            container: '#customer-section-loading',
            scale: 0.45
          })
          this.customerInfoCardLoading = true
          const shipmentObj = {
            order_notes: this.orderData.order_notes,
            is_pudo: false,
            customer: {
              id: this.orderData.customer.id,
              full_name: this.orderData.customer.full_name,
              email: this.orderData.customer.email,
              phone: this.orderData.customer.phone,
              secondary_phone: this.orderData.customer.secondary_phone ? this.orderData.customer.secondary_phone : null,
              address: {
                id: this.orderData.customer.address.id,
                zone: this.zone.id,
                line_1: this.fullAddress,
                line_2: '.'
              }
            },
            service_level: common.defineOrderType(this.orderData) === 'cash-collections' ? null : this.orderData.service_level.id
          }
          if (common.defineOrderType(this.orderData) === 'cash-collections') {
            shipmentObj.amount = this.orderData.amount
          }
          sendRequest(true, false, this, `api/v1/${common.defineOrderType(this.orderData)}/${this.$route.query.order}/`, 'patch', shipmentObj, true,
            () => {
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale]['Delivery Order'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
                position: 'top-center'
              })
              this.cancelEdit()
              this.$vs.loading.close('#customer-section-loading > .con-vs-loading')
            },
            (error) => {
              common.notifyResponseError(this, error)
              this.$vs.loading.close('#customer-section-loading > .con-vs-loading')
              this.$emit('loadOrder', 'customerInfoCardLoading')
            }
          )
        }
      })
    },
    selectZoneOptions (value) {
      const zone = value[0]
      this.zone.id = zone.id
    }
  },
  components: {
    ShipbluCard,
    vSelect
  }
}
</script>